"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extract = void 0;
const extract = (footnoteText) => {
    const pattern = new RegExp(`${"{eec_placeholder_"}([a-zA-Z0-9_|]+)[^}]*}`);
    const match = footnoteText.match(pattern);
    if (match) {
        return match[1];
    }
    return '';
};
exports.extract = extract;
//# sourceMappingURL=Extract.js.map